module.exports = __webpack_public_path__ + "static/media/lp5.bbf94e57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lp5.jpg
// module id = 1705
// module chunks = 29